<template>
  <div class="layerPop" id="loginAthChk" v-if="isVisible">
    <div class="popWrap">
      <form name="form2" method="post" ref="form2">
        <div class="popBox popType1">
          <div class="popHead" v-if="state.UpdateAthdc == 2">
            <p class="popTit">공인인증 확인</p>
          </div>
          <div class="popHead" v-if="state.UpdateAthdc == 1">
            <p class="popTit">공인인증 재등록</p>
          </div>
          <div class="popCon">
            <div class="tabStyle1">
              <p v-if="state.mstr_id_yn == 'Y'">
                <strong
                  >로그인한 ID는
                  <span class="fcRed">사업자용ID</span>입니다.</strong
                >
              </p>
              <p v-if="state.mstr_id_yn == 'Y'">
                <strong>법인공인인증 확인 후, 로그인 가능합니다.</strong>
              </p>
              <p v-if="state.mstr_id_yn != 'Y'">
                <strong
                  >로그인한 ID는
                  <span class="fcRed">업무담당자ID</span>입니다.</strong
                >
              </p>
              <p v-if="state.mstr_id_yn != 'Y'">
                <strong>개인공인인증 확인 후, 로그인 가능합니다.</strong>
              </p>
              <table>
                <tbody>
                  <tr v-if="state.mstr_id_yn == 'Y'">
                    <th scope="row">
                      <label for="txtcorpNo">사업자번호</label>
                    </th>
                    <td>
                      <div class="inpTxt typeReq">
                        <input
                          maxlength="20"
                          v-model="state.corpNo"
                          type="text"
                          id="corpNo"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr v-if="state.mstr_id_yn != 'Y'">
                    <th scope="row">
                      <label for="txtJumin">업무담당자 주민번호</label>
                    </th>
                    <td>
                      <div class="inpTxt typeReq">
                        <input
                          maxlength="6"
                          v-model="state.txtJumin_bf"
                          type="text"
                          id="txtJumin_bf"
                        />
                      </div>
                    </td>
                    -
                    <td>
                      <div class="inpTxt typeReq">
                        <input
                          maxlength="7"
                          v-model="state.txtJumin_af"
                          type="password"
                          name="txtJumin_af"
                          id="txtJumin_af"
                          npkencrypt="on"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <p v-if="state.mstr_id_yn == 'Y'" class="f11">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; * '-'은 빼고 입력바랍니다
          </p>
          <div class="popBtn" v-if="state.UpdateAthdc == 2">
            <a class="btnType sizeS colorB" @click="send()"
              ><span>공인인증 확인</span></a
            >
          </div>
          <div class="popBtn" v-if="state.UpdateAthdc == 1">
            <a class="btnType sizeS colorB" @click="sendRegi()"
              ><span>공인인증 재등록</span></a
            >
          </div>
          <slot></slot>
          <button type="button" class="popClose" @click="close()">
            <span class="hide">닫기</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  inject,
  onMounted,
  onBeforeUpdate,
  nextTick,
} from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import CryptoJS from "crypto-js";

const axios = inject("axios");
const store = useStore();

const state = reactive({
  mstr_id_yn: "",
  corpNo: "",
  txtJumin_bf: "",
  txtJumin_af: "",
  NOS_INSTANCE: {},
  logid: "",
  logpw: "",
  UpdateAthdc: "",
  athTypeCd: "2",

  //공인인증
  athdc_mbdy_enc: "",
  athdc_efct_dt: "",

  keyResult: {},
});
const isVisible = ref(false);
const swalAlert = inject("swalAlert");

const emits = defineEmits(["update:data", "close", "success"]);

const form2 = ref(null);

const open = async (object) => {
  state.keyResult = await axios.json("/getCryptoKey.do");
  npPfsStartup(document.form2, true, true, false, false, "npkencrypt", "on");

  isVisible.value = true;

  await nextTick();
  if (form2.value) {
    npPfsCtrl.RescanField();
  }

  state.corpNo = "";
  state.txtJumin_bf = "";
  state.txtJumin_af = "";

  state.mstr_id_yn = object.mstr_id_yn;
  state.athdc_mbdy_enc = object.athdc_mbdy_enc;
  state.logid = object.logid;
  state.logpw = object.logpw;
  state.athTypeCd = object.login_typ_cd;

  state.UpdateAthdc = object.UpdateAthdc; //공인인증 유효기간

  setTimeout(() => {
    $(".nppfs-elements").hide();
  }, "1000");
};

//공인인증 로그인
const send = () => {
  if (state.mstr_id_yn == "Y" && _.isEmpty(state.corpNo)) {
    return swalAlert("사업자 번호를 입력해 주세요.");
  }
  if (
    state.mstr_id_yn != "Y" &&
    _.isEmpty(state.txtJumin_bf) &&
    _.isEmpty(state.txtJumin_af)
  ) {
    return swalAlert("주민번호를 입력해주세요.");
  }
  axios.json("/genKsbizNonce.do").then(function (result) {
    if (result.errorCode != "undefined") {
      KeySharpBiz.sign("ksbizNonce=" + result.data.KSBIZ_NONCE, complete_sign, {
        addNonce: false,
      });
    } else {
      console.log(result.errorCode);
    }
  });
};

const complete_sign = (result) => {
  const param = {};
  param.ksbizSig = result.data;
  param.idn = state.mstr_id_yn == "Y" ? state.corpNo : state.txtJumin_bf;
  param.ksbizVidRandom = result.vidRandom;
  param.athdc_mbdy_enc = state.athdc_mbdy_enc;
  param.mstr_id_yn = state.mstr_id_yn;

  param.e2eRes = $("[name=__E2E_RESULT__]").val();
  param.e2eUni = $("[name=__E2E_UNIQUE__]").val();
  param.e2e = $("[name=txtJumin_af__E2E__]").val();
  param.e2epln = $("[name=txtJumin_af]").val();

  axios.json("/ofapvAthdcElcSgnVrf.do", param).then(async function (result) {
    await swalAlert(result.data.msg);
    isVisible.value = false;

    const key = state.keyResult.data.key;
    const iv = state.keyResult.data.iv;
    const keyBytes = CryptoJS.enc.Base64.parse(key);
    const ivBytes = CryptoJS.enc.Base64.parse(iv);

    const encryptedId = CryptoJS.AES.encrypt(state.logid, keyBytes, {
      iv: ivBytes,
      mode: CryptoJS.mode.CBC,
    }).toString();
    const encryptedPw = CryptoJS.AES.encrypt(state.logpw, keyBytes, {
      iv: ivBytes,
      mode: CryptoJS.mode.CBC,
    }).toString();
    const encryptedBdt = CryptoJS.AES.encrypt(state.birth_ymd, keyBytes, {
      iv: ivBytes,
      mode: CryptoJS.mode.CBC,
    }).toString();

    const param = {};
    param.encId = encryptedId;
    param.encPw = encryptedPw;
    param.login_typ_cd = state.athTypeCd;
    param.flag = "T";
    param.skipPwChg = "N";
    axios.json("/login.do", param).then(async function (result) {
      await load();
      axios.json("/logHisLdg.do", {
        memo: `공동인증${result.data.state}`,
        page: window.location.hash,
      });
      emits("success", sessionUserInfo);
    });
    // 임시 로그인 우회
    // if(result.data.state == 'N'){
    // 	return swalAlert(result.data.msg);
    // }else{
    // 	if(result.data.state == 'Y'){
    // 		await swalAlert(result.data.msg)

    // 		isVisible.value =false;

    // 		const param = {};
    // 		param.logid = state.logid;
    // 		param.logpw = state.logpw;
    // 		param.login_typ_cd = state.athTypeCd;
    // 		param.flag = "T"
    // 		axios.json('/login.do', param).then(async function(result){
    // 			await load();
    // 			emits('success', sessionUserInfo);
    // 		})
    // 	}
    // }
  });
  console.log("Call BACK");
};

//공인인증 재등록
const sendRegi = () => {
  if (state.mstr_id_yn == "Y" && _.isEmpty(state.corpNo)) {
    return swalAlert("사업자 번호를 입력해 주세요.");
  }
  if (
    state.mstr_id_yn != "Y" &&
    _.isEmpty(state.txtJumin_bf) &&
    _.isEmpty(state.txtJumin_af)
  ) {
    return swalAlert("주민번호를 입력해주세요.");
  }
  axios.json("/genKsbizNonce.do").then(function (result) {
    if (result.errorCode != "undefined") {
      KeySharpBiz.sign(
        "ksbizNonce=" + result.data.KSBIZ_NONCE,
        complete_sign_regi,
        { addNonce: false }
      );
    } else {
      console.log(result.errorCode);
    }
  });
};

const complete_sign_regi = (result) => {
  const param = {};
  param.ksbizSig = result.data;
  param.idn = state.mstr_id_yn == "Y" ? state.corpNo : state.txtJumin_bf;
  //param.idn = state.mstr_id_yn == 'Y'? state.txtJumin_bf : state.corpNo;
  param.ksbizVidRandom = result.vidRandom;
  param.mstr_id_yn = state.mstr_id_yn;
  param.sType = state.mstr_id_yn == "Y" ? "1" : "2"; //사업자 or 개인

  param.e2eRes = $("[name=__E2E_RESULT__]").val();
  param.e2eUni = $("[name=__E2E_UNIQUE__]").val();
  param.e2e = $("[name=txtJumin_af__E2E__]").val();
  param.e2epln = $("[name=txtJumin_af]").val();

  axios.json("/ofapvAthdcElcSgnVrfReg.do", param).then(async function (result) {
    console.log(result);
    if (result.data.state == "N") {
      return swalAlert(result.data.msg);
    } else {
      if (result.data.state == "Y") {
        await swalAlert(result.data.msg);
        state.athdc_mbdy_enc = result.data.subjectDN; //공인인증 유효키
        state.athdc_efct_dt = result.data.dateafter; //공인인증 만료일자
        isVisible.value = false;
        const param = {};
        param.logid = state.logid;
        param.athdc_mbdy_enc = state.athdc_mbdy_enc;
        param.athdc_efct_dt = state.athdc_efct_dt;

        axios.json("/uptAthdcRegi.do", param).then(async function (Uptresult) {
          await swalAlert(Uptresult.data.msg);
        });
      }
    }
  });
  console.log("Call BACK");
};

const logout = () => {
  axios.json("/logout.do", {}).then(function (result) {
    isVisible.value = false;
    if (result.data.state == "Y") {
      store.commit("common/chgLginChk", false);
      store.commit("common/lginAuthChk", "");
      state.lginState = "2";
      load();
    }
  });
};

const close = () => {
  isVisible.value = false;
  logout();
  emits("close");
};
defineExpose({ open, close });
</script>
